import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    privileges:[]
    
};
const staticReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_STATIC:
            return {
                ...state,
                loading: true
            };
        case actionTypes.FAILED_STATIC:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_STATIC:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default staticReducer;
